import Data from './Data';

export const Sidebar = (props) => {
  return <Data {...props} />;
};
